import { render, staticRenderFns } from "./blockBox2.vue?vue&type=template&id=d8b4c0fa"
import script from "./blockBox2.vue?vue&type=script&lang=js"
export * from "./blockBox2.vue?vue&type=script&lang=js"
import style0 from "./blockBox2.vue?vue&type=style&index=0&id=d8b4c0fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports